
import cmnViewMap from '../cmn/Index';
import systemViewMap from '../system/Index';

import VoucherHeaderEditor from "./voucher/components/VoucherHeaderEditor";
import VoucherHeaderViewer from "./voucher/components/VoucherHeaderViewer";
import VoucherHeader2 from "./voucher/components/VoucherHeader2";
import VoucherRefList from "./voucher/components/VoucherRefList";
import VoucherRefListRow from "./voucher/components/VoucherRefListRow";
import TransportPayment from "./voucher/components/TransportPayment";
import TransportPaymentRow from "./voucher/components/TransportPaymentRow";
import VoucherDetail from "./voucher/components/VoucherDetail";
import VoucherDetailRow from "./voucher/components/VoucherDetailRow";
import VoucherShorthand from "./voucher/components/VoucherShorthand";

import BudgetHeaderEditor from "./budget/Components/BudgetHeaderEditor";
import BudgetHeaderViewer from "./budget/Components/BudgetHeaderViewer";
import BudgetAction from "./budget/Components/BudgetAction";
import BudgetActionOS from "./budget/Components/BudgetActionOS";
import BudgetActionRow from "./budget/Components/BudgetActionRow";

import itemIndex from "../item/Index.js";
import prodIndex from "../project/production/Index.js"

const voucherViewMap = {
    "vVoucherHeader1Viewer":VoucherHeaderViewer,
    "vVoucherHeader1Editor":VoucherHeaderEditor,
    "vVoucherHeader2":VoucherHeader2,
    "vTransportPayment": TransportPayment,
    "vTransportPaymentRow":TransportPaymentRow,
    "vVoucherDetail": VoucherDetail,
    "vVoucherDetailRow":VoucherDetailRow,
    "vVoucherRefList":VoucherRefList,
    "vVoucherRefListRow":VoucherRefListRow,
    "vVoucherShorthand":VoucherShorthand,

    "vBudgetHeaderEditor":BudgetHeaderEditor,
    "vBudgetHeaderViewer":BudgetHeaderViewer,
    "vBudgetAction":BudgetAction,
    "vBudgetActionOS":BudgetActionOS,
    "vBudgetActionRow":BudgetActionRow,

    ...cmnViewMap,
    ...systemViewMap,
    ...itemIndex,
    ...prodIndex
}

export default voucherViewMap;